<template>
    <div class="my-toolbar-item">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "MyToolbarItem"
    }
</script>

<style scoped>
    .my-toolbar-item {
        margin: 20px 0 0 20px;
        float: left;
    }

    @media screen and (max-width: 600px) {
        .my-toolbar-item {
            width: 100% !important;
        }
    }
</style>